import { create } from 'zustand';

export interface ICompanyProfileStep {
  id: number;
  step_name: string;
  video_link: string;
  tips: string;
}

export interface ICompanyField {
  value?: unknown;
  is_published?: boolean;
}

export interface IParsedFile {
  filename?: string;
  name?: string;
  url: string;
  original_url?: string;
}

export interface ICompanyProfile {
  id?: number | string;
  tenant_id?: number | string;
  parsedFiles?: IParsedFile[];
  // Published flags
  is_published_purpose?: boolean;
  is_published_positioning?: boolean;
  is_published_vision?: boolean;
  is_published_mission?: boolean;
  is_published_culture?: boolean;
  is_published_business_goal?: boolean;
  is_published_information?: boolean;
  // Allow any additional fields (can be direct value or ICompanyField object)
  [key: string]: unknown;
}

interface CompanyState {
  companyProfile: ICompanyProfile | null;
  companyProfileSteps: ICompanyProfileStep[];
  setCompanyProfile: (profile: ICompanyProfile | null) => void;
  setCompanyProfileSteps: (steps: ICompanyProfileStep[]) => void;
  updateLocalField: (field: string, value: unknown, isPublished?: boolean) => void;
  clearCompanyProfile: () => void;
}

/**
 * Simplified Zustand store for Company Profile
 * Only handles local state management
 * All API calls moved to useCompanyProfile hook (React Query)
 */
const useCompanyState = create<CompanyState>(set => ({
  companyProfile: null,
  companyProfileSteps: [],

  setCompanyProfile: profile => set({ companyProfile: profile }),
  setCompanyProfileSteps: steps => set({ companyProfileSteps: steps }),

  updateLocalField: (field, value, isPublished = true) =>
    set(state => ({
      companyProfile: state.companyProfile
        ? {
            ...state.companyProfile,
            [field]: { value, is_published: isPublished },
          }
        : null,
    })),

  clearCompanyProfile: () => set({ companyProfile: null }),
}));

export default useCompanyState;
